import { createTheme, responsiveFontSizes } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";

const globalBorderRadius = 20;

let darkTheme = createTheme({
  direction: "rtl",
  palette: {
    type: "dark",
    primary: {
      main: "#e0e0e0",
    },
    secondary: {
      main: "#e0e0e0",
    },
    text: {
      primary: "#fff",
      secondary: "#bdbdbd",
    },
    background: { default: "#141414", paper: "#141414" },
  },
  typography: {
    fontFamily: "iranyekan",
    fontSize: 13,
  },
  shadows: Array(25).fill("none"),
  props: {
    // Name of the component ⚛️
    MuiButtonBase: {
      // The properties to apply
      disableRipple: true, // No more ripple, on the whole application 💣!
    },
  },
  transitions: {
    // So we have `transition: none;` everywhere
    // create: () => "none",
  },
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: "#141414",
        // borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
      },
    },
    MuiPaper: {
      root: {
        // backgroundColor: "transparent",
        // backdropFilter: "blur(50px)",
      },
      rounded: {
        borderRadius: globalBorderRadius,
      },
      elevation1: {
        // boxShadow: "0px 0px 15px -10px #75757566",
        boxShadow: "none",
        border: "1px solid #ffffff11",
      },
    },
    MuiDialog: {
      paper: {
        borderRadius: globalBorderRadius,
      },
    },
    MuiTextField: {
      root: {
        "& label.Mui-focused": {},
        "& .MuiInput-underline:after": {
          borderColor: grey[900],
        },
        "& .MuiOutlinedInput-root": {
          backgroundColor: grey[900],
          borderRadius: globalBorderRadius,
          "& fieldset": {
            borderColor: grey[900],
          },
          "&:hover fieldset": {
            borderColor: grey[900],
          },
          "&.Mui-focused fieldset": {
            borderColor: grey[900],
          },
        },
      },
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: grey.A200,
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: grey.A200,
        // color: "white",
      },
    },
    MuiPickersYear: {
      root: {
        "&:focus": {
          color: grey["400"],
        },
      },
      yearSelected: {
        color: grey["600"],
      },
    },
    MuiPickersDay: {
      day: {
        color: grey.A700,
      },
      daySelected: {
        backgroundColor: grey["400"],
      },
      dayDisabled: {
        color: grey["100"],
      },
      current: {
        color: grey["900"],
      },
    },
    MuiListItem: {
      root: {
        borderRadius: globalBorderRadius,
        marginBottom: 5,
      },
    },
    MuiButton: {
      contained: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none",
        },
        "&:active": {
          boxShadow: "none",
        },
      },
      textPrimary: { color: grey["600"] },
      root: {
        borderRadius: globalBorderRadius,
      },
    },
    MuiDrawer: {
      paperAnchorDockedRight: {
        borderLeft: "none",
      },
    },
    MuiTableCell: {
      root: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: 145,
        minWidth: 145,
        // transition: "all 200ms ease",
        border: 0,
        // fontWeight: 600,
        // ":hover": {
        //   maxWidth: "unset",
        //   position: "absolute",
        //   backdropFilter: "brightness(1000%)",
        // boxShadow: "0px 0px 5px #75757533",
        // backgroundColor: "#fff",
        // transition: "all 200ms ease",
        // borderRadius: 6,
        //   border: 0,
        // },
      },
    },
  },
});

darkTheme = responsiveFontSizes(darkTheme);

export default darkTheme;
